    import React                            from 'react';
    import DoaIcon                          from '../images/DoaIcon.svg';
    import MerceDanneggiataIcon             from '../images/MerceDanneggiata.svg';
    import MerceNonConformeIcon             from '../images/MerceNonConforme.svg';
    import BuildIcon                        from '@mui/icons-material/Build';
    import AddIcon                          from '@mui/icons-material/Add';
    import { useNavigate }                  from 'react-router-dom';
    import { useTranslation }           from 'react-i18next';
    
    import { 
        Avatar, 
        Container, 
        Tooltip 
    } from '@mui/material';




    const IconNavigationMenu = ({ onIconClick, activeTab }) => {
        const navigate = useNavigate();
        const { t } = useTranslation();


        const handleNavigateReso = () => {
            switch (activeTab) {
                case 'Riparazione':
                    navigate('/riparazione');
                    break;
                case 'DOA':
                    navigate('/DOA');
                    break;
                case 'MerceDanneggiata':
                    navigate('/MerceDanneggiata');
                    break;
                case 'MerceNonConforme':
                    navigate('/MerceNonConforme');
                    break;
                default:
                    navigate('/'); 
            }
        };

    return (
        <Container
        maxWidth="false"
        sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 3,
            pl: 6,
            flexDirection: 'row',
            mt: 4
        }}
        >
        {/* Icona Riparazione */}
        <Tooltip title={t("Riparazioni")}>
        <Avatar
            sx={{
            width: activeTab === 'Riparazione' ? 80 : 60,
            height: activeTab === 'Riparazione' ? 80 : 60,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundImage: activeTab === 'Riparazione'
                ? 'linear-gradient(90deg, #28334B 0%, #263F78 100%)'
                : 'none',
            backgroundColor: activeTab !== 'Riparazione' ? '#C0C0C0' : 'transparent',
            cursor: 'pointer',
            transition: 'all 0.9s ease', 
            }}
            onClick={() => onIconClick('Riparazione')}
        >
            <BuildIcon sx={{ color: 'white', fontSize: '2.5rem' }} />
        </Avatar>
        </Tooltip>

        {/* Icona DOA */}
        <Tooltip title="DOA">
        <Avatar
            sx={{
            width: activeTab === 'DOA' ? 80 : 60,
            height: activeTab === 'DOA' ? 80 : 60,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundImage: activeTab === 'DOA'
                ? 'linear-gradient(90deg, #975F24 0%, #FDA03D 100%)'
                : 'none',
            backgroundColor: activeTab !== 'DOA' ? '#C0C0C0' : 'transparent',
            cursor: 'pointer',
            transition: 'all 0.9s ease',
            }}
            onClick={() => onIconClick('DOA')}
        >
            <img src={DoaIcon} alt="DOA Icon" style={{ width: '70%', height: '70%' }} />
        </Avatar>
        </Tooltip>

        {/* Icona Merce Danneggiata */}
        <Tooltip title={t("Merce Danneggiata")}>
        <Avatar
            sx={{
            width: activeTab === 'MerceDanneggiata' ? 80 : 60,
            height: activeTab === 'MerceDanneggiata' ? 80 : 60,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundImage: activeTab === 'MerceDanneggiata'
                ? 'linear-gradient(90deg, #123727 0%, #3DFD5D 100%)'
                : 'none',
            backgroundColor: activeTab !== 'MerceDanneggiata' ? '#C0C0C0' : 'transparent',
            cursor: 'pointer',
            transition: 'all 0.9s ease',
            }}
            onClick={() => onIconClick('MerceDanneggiata')}
        >
            <img src={MerceDanneggiataIcon} alt="Merce Danneggiata Icon" style={{ width: '70%', height: '70%' }} />
        </Avatar>
        </Tooltip>

        {/* Icona Merce Non Conforme */}
        <Tooltip title={t("Merce non conforme all'ordine")}>
        <Avatar
            sx={{
            width: activeTab === 'MerceNonConforme' ? 80 : 60,
            height: activeTab === 'MerceNonConforme' ? 80 : 60,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundImage: activeTab === 'MerceNonConforme'
                ? 'linear-gradient(90deg, #952828 0%, #FD6D3D 100%)'
                : 'none',
            backgroundColor: activeTab !== 'MerceNonConforme' ? '#C0C0C0' : 'transparent',
            cursor: 'pointer',
            transition: 'all 0.9s ease', 
            }}
            onClick={() => onIconClick('MerceNonConforme')}
        >
            <img src={MerceNonConformeIcon} alt="Merce Non Conforme Icon" style={{ width: '70%', height: '70%' }} />
        </Avatar>
        </Tooltip>

         {/* Icona per aggiungere un nuovo reso */}
        <Tooltip title={t('Aggiungi un nuovo reso')}>
        <Avatar
            sx={{
            width: activeTab === 'NuovoReso' ? 80 : 60,
            height: activeTab === 'NuovoReso' ? 80 : 60,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#FDA03D',
            cursor: 'pointer',
            '&:hover': {
                transform: 'scale(1.03)',
                backgroundColor: '#FDA03D',
                transition: 'all 0.9 ease',
            }
            }}
            onClick={handleNavigateReso}
        >
            <AddIcon sx={{ color: 'white', fontSize: '2.5rem' }} />
            </Avatar>
        </Tooltip>
        </Container>
    );
    };

    export default IconNavigationMenu;
